import moment from 'moment-timezone'
import { ChildsSlots } from '@/types/StaffRate.ts'
import { OccasionalSlot, RegularSlot } from '@/types/Slots'

export function computeChildCount(childs: ChildsSlots[]): number {
    return childs.filter(
        (child: ChildsSlots): boolean =>
            child.occasionalSlots.length > 0 || !child.regularSlots.some((slot: RegularSlot): boolean => slot.absence)
    ).length
}

export function computeAvailableHoursCount(slots: OccasionalSlot[], merger: boolean): number {
    if (merger) {
        return slots.reduce(
            (acc: number, slot: OccasionalSlot): number =>
                acc + moment(slot.end, 'HH:mm').diff(moment(slot.start, 'HH:mm'), 'hours'),
            0
        )
    }
    return slots.length
}
